import * as pages from 'pages'
import {
  BrowserRouter
} from 'react-router-dom'

const Routes = () => {
  return (
    //@ts-ignore
    <BrowserRouter>
      {/* <pages.Home /> */}
      <pages.Pay />

      {/* @ts-ignore */}
      {/* <Switch> */}
        {/* @ts-ignore */}
        {/* <Route exact path={links.pay} component={pages.Pay} /> */}
        {/* @ts-ignore */}
        {/* <Route exact path={links.generateLinkTestVocational} component={pages.Home} /> */}
        {/* @ts-ignore */}
        {/* <Route path={links.notFound} component={pages.NotFound} /> */}
        {/* @ts-ignore
         <Route path='*' children={<Redirect to={links.pay} />} /> */}
      {/* </Switch> */}
    </BrowserRouter>
  )
}

export default Routes
